import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Loading } from "../../baseComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

const SecureRoute = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const currentSector = useSelector((state: RootState) => state.user.currentSector);

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      const originalUri = location.pathname + location.search;
      oktaAuth.setOriginalUri(originalUri);
      navigate("/login");
    }
  }, [authState, oktaAuth, navigate, location]);

  useEffect(() => {
    // Check if we're trying to access rootcauseanalysis and sector is LATAM
    if (currentSector?.sector === 'LATAM' && location.pathname.includes('/rootcauseanalysis')) {
      navigate('/statisticalforecastanalysis');
    }
  }, [currentSector, location.pathname, navigate]);

  if (!authState || !authState?.isAuthenticated) {
    return <Loading />;
  }

  return <Outlet />;
};

export default SecureRoute;
